<app-header [cliente]="cliente" [historico]="true" [logado]="true"></app-header>
<div class="container-fluid container-principal">
    <app-pedido-cliente-card  [pedidos]="pedidos"></app-pedido-cliente-card>
</div>
<app-footer-logado></app-footer-logado>